import { useCallback } from "react";
import { Product, ProductPrice } from "src/api/types";

export const useGeneratePaymentLink = () => {
  const generatePaymentLink = useCallback(
    (product: Product, price: ProductPrice, quantity?: number) => {
      const appUrl =
        import.meta.env.VITE_REDIRECT_LINK ?? "https://app.holavida.com";

      const form = price.name.match(/^(?<form>Oral|Serum|Topical)/i)?.groups
        ?.form;
      const variant = price.name.match(
        /^(?<variant>Boss\+\(Tadalafil\)|Boss\+\(Sildenafil\)|Boss Max)/i,
      )?.groups?.variant;
      const dosage = price.name.match(/^(?<dosage>\d+(?:\.\d+)?mg)/i)?.groups
        ?.dosage;

      const queryParams = new URLSearchParams();
      queryParams.append("id", price.stripe_id);
      queryParams.append("amount", `${price.amount}`);

      if (dosage != null) {
        queryParams.append("dosage", dosage);
      }

      if (form != null) {
        queryParams.append("form", form === "Serum" ? "Dropper" : form);
      }

      if (variant != null) {
        queryParams.append("variant", variant);
      }

      if (quantity != null) {
        queryParams.append("quantity", quantity.toString());
      }

      return `${appUrl}/add-ons/${product.slug}?${queryParams.toString()}`;
    },
    [],
  );

  return { generatePaymentLink };
};
